exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='dashboard'] .content {\n  transform-origin: top;\n}\n[data-component='dashboard'] .applications {\n  border: 1px solid transparent;\n  height: 213px;\n  position: relative;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/dashboard.component.styl
// module id = ../../../../../src/app/master/dashboard/dashboard.component.styl
// module chunks = main